import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ECookiesActionTypes {
  CookiesAccepted = 'cookies/cookiesAccepted',
  SetHideOnboardingByCookie = 'cookies/setHideOnboarding',
  SetFullscreenBannerByCookie = 'cookies/setFullscreenBanner',
}

export type TCookiesAccepted = ITypedReduxAction<ECookiesActionTypes.CookiesAccepted>;
export type TSetHideOnboardingByCookie = ITypedReduxAction<ECookiesActionTypes.SetHideOnboardingByCookie>;
export type TSetFullscreenBannerByCookie = ITypedReduxAction<ECookiesActionTypes.SetFullscreenBannerByCookie>;

export type TCookiesActions = TCookiesAccepted | TSetHideOnboardingByCookie | TSetFullscreenBannerByCookie;
